import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { withDefaults } from "vue";

import XIcon from "@/components/icons/XIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PhotoPopup',
  props: {
    image: {}
  },
  emits: ["close"],
  setup(__props: any) {

const props = __props;




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "popup bg-gray-600 modal-animation fixed top-0 bottom-0 left-0 right-0 z-30 h-screen w-full flex flex-col justify-center items-center py-16 bg-opacity-50 dark:bg-opacity-50",
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit(`close`)), ["self"]))
  }, [
    _createElementVNode("button", {
      class: "bg-gray-300 dark:bg-gray5 focus:outline-none mb-5 rounded-full p-1 w-8 h-8",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(`close`)))
    }, [
      _createVNode(XIcon, { class: "w-6 h-6" })
    ]),
    _createElementVNode("img", {
      src: props.image,
      alt: "",
      srcset: "",
      class: "modal-content rounded-lg overflow-hidden object-contain m-0 p-0"
    }, null, 8, _hoisted_1)
  ]))
}
}

})